import { setBetValueGlobal } from "../config/GlobalVariableConfig";

// import { spinResponseDataGlobal } from "../config/GlobalVariableConfig";

import { REEL_NUMBERS } from "../config/reelConfig";
const numberUnit = 0.01; // in cents


export interface WinObject { // the object -how we want to use in our program 
    lineId: number | null;
    symbolId: number;
    winAmount: number;
    winSymbolPosistions: number[][] | null;
    winMultiplier: number;
    bonusWon: string;
}

export interface SwirlObject { // the object -how we want to use in our program 
    reelNum: number;
    posNum: number;
    addedMult: number;
    updatedRespinMult: number;
    positions: number[][];
}


export interface GiantWildPositions {
    positions: number[][];
}




export interface RespinObject { // the object -how we want to use in our program 

    type: string;
    freeGameTrigger: number;
    respinMultiplier: number;
    surgeMeter: number;
    reelSymbols: number[][];
    winLines: WinObject[] | null; // Making winLines optional because might be no win
    winScatters: WinObject[] | null;
    winAmount: number; // win of that particular respin 
    // multiplier: number; // accumulated multiplier applicable on  that particular respin 
    giantWilds: GiantWildPositions[] | null;
    accumulatedsWinAmount: number; // win of that particular respin 
    cascadePositions: number[][];
    swirl: SwirlObject[];

}

export interface SpinDataObject { // the object -how we want to use in our program 

    dataFeatched: boolean;

    betAmount: number;

    // state value - kind of header
    freeGameTrigger: number; // number of fs won in base game
    freeGameReTrigger: number;  // number of fs won in free game
    totalFreeGame: number; // total number of fs - to show in counter 
    remainingFreeGame: number; // remaining number of fs - to show in counter 
    totalAccumulatedWin: number; // used specially in free games
    totalWin: number;  // win of current spin including all respins
    balance: number;
    isWinHigherBet: boolean;

    respins: RespinObject[];

};



export const spinData: SpinDataObject = { // use in other class

    dataFeatched: false,

    betAmount: 0,
    freeGameTrigger: 0,
    freeGameReTrigger: 0,
    totalFreeGame: 0,
    remainingFreeGame: 0,
    totalAccumulatedWin: 0,
    totalWin: 0,
    balance: 0,
    isWinHigherBet: false,
    respins: []
};

export function resetSpinData(): void {
    spinData.dataFeatched = false;

    spinData.freeGameTrigger = 0;
    spinData.freeGameReTrigger = 0;
    spinData.totalFreeGame = 0;
    spinData.remainingFreeGame = 0;
    spinData.totalAccumulatedWin = 0;
    spinData.totalWin = 0;
    spinData.balance = 0;
    spinData.isWinHigherBet = false;

    spinData.respins = [];
}


// export async function spinResponse(): Promise<void> {

//     console.log('insidespinResponse');

//     parserSpinResponse(spinResponseDataGlobal);

// }



export function parserSpinResponse(data: any): void {
    console.log("inside parserSpinResponse", data);



    // Initialize the SpinDataObject
    spinData.dataFeatched = true;

    spinData.betAmount = Number(data.betAmountString) / 100;
    setBetValueGlobal(spinData.betAmount);

    if (Number(data.latestWinString) > Number(data.betAmountString)) {
        spinData.isWinHigherBet = true;
    } else {
        spinData.isWinHigherBet = false;
    }

    data.events.forEach((event: any) => {

        // Each spin will be treated as a respin
        const reelSymbols: number[][] = (event.c && event.c.grid) ? decodeGrid(event.c.grid) : [];
        // console.log(reelSymbols);

        const respinWinAmount = Number(event.wa * numberUnit);  // Total win of that particular respin
        // console.log(winAmount);

        const accumWinAmount = Number(event.awa * numberUnit);  // Total win of that particular respin

        const type = event.etn;

        // // Check for feature spin (e.g., free game trigger)
        let freeGameTrigger = 0;
        if (event.etn === "feature_enter") {
            freeGameTrigger = Number(event.c.bonusFeatureCount) || 0;
            spinData.freeGameTrigger = Number(event.c.bonusFeatureCount) || 0;
            spinData.totalFreeGame = Number(event.c.bonusFeatureCount) || 0;
        }

        const winLines: WinObject[] = [];
        const winScatters: WinObject[] = [];
        const giantWilds: GiantWildPositions[] = [];
        const cascadePositions: number[][] = [];
        const swirl: SwirlObject[] = [];

        let respinMultiplier = 0;
        let surgeMeter = 0;

        event.c && event.c.actions?.forEach((action: any) => {
            if (action.at === "currentMulti") { // Handling wild multiplier
                respinMultiplier = Number(action.data.m);
            }
            else if (action.at === "currentSurgeMeter") { // Handling wild multiplier
                surgeMeter = Number(action.data.v);
            }
            else if (action.at === "gridwin") { // Handling win lines or win scatters
                const symbolId = Number(action.data.symbol);
                const lineId = Number(action.data.lineId) || null;
                const winAmount = Number(action.data.winAmount * numberUnit);
                const winSymbolPositions = action.data.mask ? getReelPositions(action.data.mask) : [];
                const winMultiplier = action.data.winMultipliers ? Number(action.data.winMultipliers[0]) : 1;
                const bonusWon = action.data.bonusWon || ""; // Assuming you want to track bonus wins

                const winObject: WinObject = {
                    lineId,
                    symbolId,
                    winAmount,
                    winSymbolPosistions: winSymbolPositions.length > 0 ? winSymbolPositions : null,
                    winMultiplier,
                    bonusWon
                };

                if (symbolId === 12) { // Assuming symbol 12 is a scatter
                    winScatters.push(winObject);
                } else {
                    winLines.push(winObject);
                }
            }
            else if (action.at === "placeGiantWilds") { // Handling wild multiplier

                action.data.p.forEach((position: any) => {
                    const wildPositions: number[][] = [];

                    position.forEach((value: number) => {
                        const wildSymbolPosition: [number, number] = [value % REEL_NUMBERS, Math.floor(value / REEL_NUMBERS)];
                        wildPositions.push(wildSymbolPosition);
                    });

                    giantWilds.push({ positions: wildPositions }); // Correct property name
                });
            }
            else if (action.at === "replace") { // Handling special candy

                const [swirlReelNum, swirlPosNum] = [action.data.p % REEL_NUMBERS, Math.floor(action.data.p / REEL_NUMBERS)];

                let swirlPositions: number[][] = [];

                // add the swril position itself
                swirlPositions.push([swirlReelNum, swirlPosNum]);

                action.data.wilds.forEach((position: any) => {
                    const [reelNum, posNum] = [position % REEL_NUMBERS, Math.floor(position / REEL_NUMBERS)];
                    swirlPositions.push([reelNum, posNum]);
                })

                let swirlMult: number = action.data.added ? Number(action.data.added) : 0;
                let updatedRespinMult: number = action.data.m ? Number(action.data.m) : 0;

                const swirlObject: SwirlObject = {
                    reelNum: swirlReelNum,
                    posNum: swirlPosNum,
                    addedMult: swirlMult,
                    updatedRespinMult: updatedRespinMult,
                    positions: swirlPositions
                };

                swirl.push(swirlObject);

            }
            else if (action.at === "remove") { // Handling wild multiplier

                action.data.mask ? getReelPositions(action.data.mask) : [];
                const mask = action.data.mask; // Mask as string of 0s and 1s

                if (mask.length > 0) {
                    for (let i = 0; i < mask.length; i++) {
                        if (mask[i] === '1') { // Only process positions marked as '1'
                            const position: [number, number] = [
                                i % REEL_NUMBERS,               // Reel Number
                                Math.floor(i / REEL_NUMBERS)    // Position
                            ];
                            cascadePositions.push(position);
                        }
                    }
                }
            }

        });

        // Create the RespinObject and push it to spinData.respins
        const respin: RespinObject = {
            type: type,
            freeGameTrigger: freeGameTrigger,
            respinMultiplier: respinMultiplier,
            surgeMeter: surgeMeter,
            reelSymbols: reelSymbols,
            winLines: winLines.length > 0 ? winLines : null,
            winScatters: winScatters.length > 0 ? winScatters : null,
            winAmount: respinWinAmount,
            cascadePositions: cascadePositions,
            // multiplier: totalMultiplier,
            giantWilds: giantWilds.length > 0 ? giantWilds : null,
            accumulatedsWinAmount: accumWinAmount,
            swirl: swirl
        };




        spinData.respins.push(respin);




    });

    console.log("Parsed spin data:", spinData);

}


function decodeGrid(grid: string): number[][] {
    const offset = 40; // ASCII offset for encoding

    // Extract width and height from the first two characters
    const width = grid.charCodeAt(0) - offset;
    const height = grid.charCodeAt(1) - offset;

    // Initialize the 2D array for storing the grid
    const gridArray = [];

    // Populate the 2D array with decoded values
    let index = 2; // Start from the third character
    for (let row = 0; row < height; row++) {
        const currentRow = [];
        for (let col = 0; col < width; col++) {
            // Convert each character to its decimal value using the offset
            const cellValue = grid.charCodeAt(index) - offset;
            currentRow.push(cellValue);
            index++;
        }
        gridArray.push(currentRow);
    }


    // console.log(gridArray);

    // Transpose the 2D array (swap rows with columns)
    const transposedArray = transposeMatrix(gridArray);

    // function to transpose a matrix (2D array)
    function transposeMatrix(matrix: number[][]) {
        return matrix[0].map((_, colIndex) => matrix.map(row => row[colIndex]));
    }

    return transposedArray;

}

function getReelPositions(binaryString: string): [number, number][] {

    // const rows = Math.ceil(binaryString.length / REEL_NUMBERS);
    const result: [number, number][] = [];

    // Loop through the binary string and fill the 2D array conceptually
    for (let i = 0; i < binaryString.length; i++) {
        const reelId = i % REEL_NUMBERS;          // Column number (reelId)
        const positionNum = Math.floor(i / REEL_NUMBERS); // Row number (position)

        if (binaryString[i] === '1') {
            result.push([reelId, positionNum]);
        }
    }

    return result;
}



